export const PROFESSION_OPTIONS = [
  'Artist',
  'Content Creator',
  'Creative',
  'Dancer (Club Performer / Stage Dancer)',
  'DJ',
  'Event Planner',
  'Event Promoter',
  'Freelance Bartender',
  'Freelance Security Contractor',
  'Graphic Designer',
  'Lighting Technician',
  'Live Musician (Bands, Singers, Instrumentalists)',
  'MC / Host',
  'Photographer',
  'Sound Engineer',
  'Stage Manager',
  'Videographer',
  'Other',
];
